export const appAdditions = {
  pomodoro: {
    name: "Pomodoro Sauce",
    servings: 0,
    price: 0.75
  }
}

export const appSauces = {
  buffalo: {
    name: "Buffalo",
    servings: 0
  },
  teriyaki: {
    name: "Teriyaki",
    servings: 0
  },
  bbq: {
    name: "BBQ",
    servings: 0
  },
  ketchup: {
    name: "Ketchup",
    servings: 0
  },
  mayo: {
    name: "Mayo",
    servings: 0
  },
  mustard: {
    name: "Mustard",
    servings: 0
  },
  spicyMustard: {
    name: "Spicy Mustard",
    servings: 0
  },
  honeyMustard: {
    name: "Honey Mustard",
    servings: 0
  },
  chipotle: {
    name: "Chipotle",
    servings: 0
  },
  pesto: {
    name: "Pesto",
    servings: 0
  },
  horseradishCream: {
    name: "Horseradish Cream",
    servings: 0
  }
}

export const chxWingSauces = {
  buffalo: {
    name: "Buffalo",
    servings: 0
  },
  teriyaki: {
    name: "Teriyaki",
    servings: 0
  },
  bbq: {
    name: "BBQ",
    servings: 0
  },
  chipotle: {
    name: "Chipotle",
    servings: 0
  },
}

export const deliUnitList = [
  "Wheat Wrap",
  "White Wrap",
  "Panini",
  "Foccacia",
  "Sliced Tuscan"
]

export const deliAdditions = {
  bacon: {
    name: "Bacon",
    servings: 0,
    price: 1.00
  },
  redRoastedPeppers: {
    name: "Red Roasted Peppers",
    servings: 0,
    price: 1.00
  },
  americanCheese: {
    name: "American Cheese",
    servings: 0,
    price: 1.00
  },
  sharpProvoloneCheese: {
    name: "Sharp Provolone Cheese",
    servings: 0,
    price: 2.00
  },
  mildProvoloneCheese: {
    name: "Mild Provolone Cheese",
    servings: 0,
    price: 1.00
  },
  swissCheese: {
    name: "Swiss Cheese",
    servings: 0,
    price: 1.00
  },
  cheddarCheese: {
    name: "Cheddar Cheese",
    servings: 0,
    price: 1.00
  }
}

export const deliSpreads = {
  mayo: {
    name: "Mayo",
    servings: 0
  },
  mustard: {
    name: "Mustard",
    servings: 0
  },
  spicyMustard: {
    name: "Spicy Mustard",
    servings: 0
  },
  honeyMustard: {
    name: "Honey Mustard",
    servings: 0
  },
  ketchup: {
    name: "Ketchup",
    servings: 0
  },
  chipotle: {
    name: "Chipotle",
    servings: 0
  },
  pesto: {
    name: "Pesto",
    servings: 0
  },
  horseradishCream: {
    name: "Horseradish Cream",
    servings: 0
  }
}

export const subAdditions = {
  sauteedPeppers: {
    name: "Sauteed Peppers",
    servings: 0,
    price: 0.75
  },  
  sauteedOnions: {
    name: "Sauteed Onions",
    servings: 0,
    price: 0.75
  },
  sauteedMushrooms: {
    name: "Sauteed Mushrooms",
    servings: 0,
    price: 0.75
  },
  americanCheese: {
    name: "American Cheese",
    servings: 0,
    price: 1.00
  },
  sharpProvoloneCheese: {
    name: "Sharp Provolone Cheese",
    servings: 0,
    price: 2.00
  },
  mildProvoloneCheese: {
    name: "Mild Provolone Cheese",
    servings: 0,
    price: 1.00
  },
  swissCheese: {
    name: "Swiss Cheese",
    servings: 0,
    price: 1.00
  },
  cheddarCheese: {
    name: "Cheddar Cheese",
    servings: 0,
    price: 1.00
  },
  mozzarella: {
    name: "Mozzarella Cheese",
    servings: 0,
    price: 1.00
  }
}

export const salAdditions = {
  grilledChicken: {
    name: "Grilled Chicken",
    servings: 0,
    price: 2.00
  },
  breadedChicken: {
    name: "Breaded Chicken",
    servings: 0,
    price: 2.00
  },
  chickenSalad: {
    name: "Chicken Salad",
    servings: 0,
    price: 3.00
  },
  tunaSalad: {
    name: "American Tuna Salad",
    servings: 0,
    price: 3.00
  }
}

export const salDressings = {
  caesar: {
    name: "Caesar",
    servings: 0
  },
  ranch: {
    name: "Ranch",
    servings: 0
  },
  balsamic: {
    name: "Balsamic",
    servings: 0
  },
  houseVinaigrette: {
    name: "House Vinaigrette",
    servings: 0
  },
  italian: {
    name: "Italian",
    servings: 0
  },
  creamyItalian: {
    name: "Creamy Italian",
    servings: 0
  },
  thousandIsland: {
    name: "Thousand Island",
    servings: 0
  },
  blueCheese: {
    name: "Blue Cheese",
    servings: 0
  },
  evoo: {
    name: "Extra Virgin Olive Oil",
    servings: 0
  }
}

export const calAdditions = {
  pepperoni: {
    name: "Pepperoni",
    servings: 0,
    price: 1.00
  },
  crumbledSausage: {
    name: "Crumbled Sausage",
    servings: 0,
    price: 1.00
  },
  bacon: {
    name: "Bacon",
    servings: 0,
    price: 1.00
  },
  ham: {
    name: "Ham",
    servings: 0,
    price: 1.00
  },
  meatballs: {
    name: "Meatballs",
    servings: 0,
    price: 1.00
  },
  grilledChicken: {
    name: "Grilled Chicken",
    servings: 0,
    price: 1.00
  },
  capicollo: {
    name: "Capicollo",
    servings: 0,
    price: 1.00
  },
  prosciutto: {
    name: "Prosciutto",
    servings: 0,
    price: 1.00
  },
  pineapple: {
    name: "Pineapple",
    servings: 0,
    price: 1.00
  },
  eggplant: {
    name: "Eggplant",
    servings: 0,
    price: 1.00
  },  
  slicedTomato: {
    name: "Sliced Tomato",
    servings: 0,
    price: 1.00
  },
  onion: {
    name: "Onion",
    servings: 0,
    price: 1.00
  },
  caramelizedOnion: {
    name: "Caramelized Onion",
    servings: 0,
    price: 1.00
  },  
  pepper: {
    name: "Pepper",
    servings: 0,
    price: 1.00
  },
  hotPepperRings: {
    name: "Hot Pepper Rings",
    servings: 0,
    price: 1.00
  },
  mushroom: {
    name: "Mushroom",
    servings: 0,
    price: 1.00
  },
  spinach: {
    name: "Spinach",
    servings: 0,
    price: 1.00
  },
  olives: {
    name: "Olives",
    servings: 0,
    price: 1.00
  },
  broccoli: {
    name: "Broccoli",
    servings: 0,
    price: 1.00
  },
  artichokes: {
    name: "Artichokes",
    servings: 0,
    price: 1.00
  },
  anchovies: {
    name: "Anchovies",
    servings: 0,
    price: 1.00
  }  
}

export const dinAdditions = {
  meatball: {
    name: "Meatball",
    servings: 0,
    price: 2.00
  }
}

export const pizAdditions = {
  pepperoni: {
    name: "Pepperoni",
    servings: 0,
    price: 1.00
  },
  crumbledSausage: {
    name: "Crumbled Sausage",
    servings: 0,
    price: 1.00
  },
  bacon: {
    name: "Bacon",
    servings: 0,
    price: 2.00
  },
  ham: {
    name: "Ham",
    servings: 0,
    price: 1.00
  },
  meatball: {
    name: "Meatball",
    servings: 0,
    price: 1.00
  },
  grilledChicken: {
    name: "Grilled Chicken",
    servings: 0,
    price: 1.00
  },
  chickenCutlet: {
    name: "Chicken Cutlet",
    servings: 0,
    price: 1.00
  },
  capicollo: {
    name: "Capicollo",
    servings: 0,
    price: 1.00
  },
  prosciutto: {
    name: "Prosciutto",
    servings: 0,
    price: 1.00
  },
  anchovie: {
    name: "Anchovie",
    servings: 0,
    price: 1.00
  },
  eggplant: {
    name: "Eggplant",
    servings: 0,
    price: 1.00
  },  
  slicedTomato: {
    name: "Sliced Tomato",
    servings: 0,
    price: 1.00
  },
  mushroom: {
    name: "Mushroom",
    servings: 0,
    price: 1.00
  },
  pineapple: {
    name: "Pineapple",
    servings: 0,
    price: 1.00
  },
  pepper: {
    name: "Pepper",
    servings: 0,
    price: 1.00
  },
  hotPepperRing: {
    name: "Hot Pepper Ring",
    servings: 0,
    price: 1.00
  },
  roastedPepper: {
    name: "Roasted Pepper",
    servings: 0,
    price: 1.00
  },
  onion: {
    name: "Onion",
    servings: 0,
    price: 1.00
  },
  caramelizedOnion: {
    name: "Caramelized Onion",
    servings: 0,
    price: 1.00
  },  
  spinach: {
    name: "Spinach",
    servings: 0,
    price: 1.00
  },
  broccoli: {
    name: "Broccoli",
    servings: 0,
    price: 1.00
  },
  olive: {
    name: "Olive",
    servings: 0,
    price: 1.00
  },
  artichoke: {
    name: "Artichoke",
    servings: 0,
    price: 1.00
  },
  freshBasil: {
    name: "Fresh Basil",
    servings: 0,
    price: 1.00
  },
  freshGarlic: {
    name: "Fresh Garlic",
    servings: 0,
    price: 1.00
  },
  feta: {
    name: "Feta",
    servings: 0,
    price: 1.00
  },
  shreddedMoz: {
    name: "Shredded Mozzarella",
    servings: 0,
    price: 1.00
  },
  freshMoz: {
    name: "Fresh Mozzarella",
    servings: 0,
    price: 1.00
  },
  ricotta: {
    name: "Ricotta",
    servings: 0,
    price: 1.00
  },
  shavedParm: {
    name: "Shaved Parmesan",
    servings: 0,
    price: 1.00
  },
  blueCheese: {
    name: "Blue Cheese",
    servings: 0,
    price: 1.00
  },
  goatCheese: {
    name: "Goat Cheese",
    servings: 0,
    price: 1.00
  },
}

export const pizSpreads = {
  tomatoSauce: {
    name: "Tomato Sauce",
    servings: 1
  },
  bbqSauce: {
    name: "BBQ Sauce",
    servings: 0
  },
  ranch: {
    name: "Ranch",
    servings: 0
  },
  buffalo: {
    name: "Buffalo",
    servings: 0
  },  
  pesto: {
    name: "Pesto",
    servings: 0
  },
}
